export function getArrayOfNLastYears(numberOfYears: number) {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: numberOfYears }, (_, index) => {
        const year = currentYear - index;
        return year;
    })
}